module.exports = __webpack_public_path__ + "img/TextBlockWithMap.415c09b2.png";